<div class="flex justify-content-around flex-wrap max-w-screen h-4rem">
	<div class="grid col-12 align-items-center justify-content-center py-3 surface-900">
		<img class="cursor-pointer" src="/assets/images/logos/cameconnect-log-in.png" alt="Logo" style="height:2.5rem;" (click)="backToLogin()" />
	</div>
</div>
